import {
    DASHBOARD_PANEL_SEARCH,
    DASHBOARD_PANEL_SEARCH_RESPONSE,
    DASHBOARD_PANEL_CREATE,
    DASHBOARD_PANEL_CREATE_RESPONSE,
    DASHBOARD_PANEL_UPDATE,
    DASHBOARD_PANEL_UPDATE_RESPONSE,
    DASHBOARD_PANEL_DELETE,
    DASHBOARD_PANEL_DELETE_RESPONSE,
    DASHBOARD_PANEL_OPEN_CREATE,
    DASHBOARD_PANEL_OPEN_CREATE_EDIT_MODAL,
    DASHBOARD_PANEL_SIZE_CREATE_EDIT_MODAL,
    DASHBOARD_PANEL_CREATE_GADGET,
    DASHBOARD_PANEL_CREATE_GADGET_RESPONSE,
    DASHBOARD_PANEL_UPDATE_GADGET,
    DASHBOARD_PANEL_UPDATE_GADGET_RESPONSE,
    DASHBOARD_PANEL_UPDATE_POSITION_GADGET,
    DASHBOARD_PANEL_UPDATE_POSITION_GADGET_RESPONSE,
    DASHBOARD_PANEL_UNIT,
    DASHBOARD_PANEL_UNIT_RESPONSE,
    DASHBOARD_PANEL_ERROR_USER_GADGET_RESPONSE
} from "Redux/actionTypes";

export const searchDashboardPanel = () => ({
    type: DASHBOARD_PANEL_SEARCH,
    payload: {},
})

export const searchDashboardPanelResponse = (data) => ({
    type: DASHBOARD_PANEL_SEARCH_RESPONSE,
    payload: data,
})

export const openDashboardPanelCreateEditModal = (open, gadGet = {}) => ({
    type: DASHBOARD_PANEL_OPEN_CREATE_EDIT_MODAL,
    payload: { open, gadGet }
})

export const sizeDashboardPanelCreateEditModal = (size) => ({
    type: DASHBOARD_PANEL_SIZE_CREATE_EDIT_MODAL,
    payload: { size }
})

export const createDashboardPanel = (dashboard) => ({
    type: DASHBOARD_PANEL_CREATE,
    payload: dashboard,
})

export const createDashboardPanelResponse = (data) => ({
    type: DASHBOARD_PANEL_CREATE_RESPONSE,
    payload: data,
})

export const updateDashboardPanel = (dashboard) => ({
    type: DASHBOARD_PANEL_UPDATE,
    payload: dashboard,
})

export const updateDashboardPanelResponse = (data) => ({
    type: DASHBOARD_PANEL_UPDATE_RESPONSE,
    payload: data,
})

export const deleteDashboardPanel = (dashboardId) => ({
    type: DASHBOARD_PANEL_DELETE,
    payload: dashboardId,
})

export const deleteDashboardPanelResponse = (data) => ({
    type: DASHBOARD_PANEL_DELETE_RESPONSE,
    payload: data,
})

export const openDashboardPanel = (open, dashboardEdit) => ({
    type: DASHBOARD_PANEL_OPEN_CREATE,
    payload: { open, dashboardEdit }
})

export const createGadgetDashboardPanel = (gadGet) => ({
    type: DASHBOARD_PANEL_CREATE_GADGET,
    payload: { gadGet },
})

export const createGadgetDashboardPanelResponse = (data) => ({
    type: DASHBOARD_PANEL_CREATE_GADGET_RESPONSE,
    payload: data,
})

export const updateGadgetDashboardPanel = (gadGet) => ({
    type: DASHBOARD_PANEL_UPDATE_GADGET,
    payload: { gadGet },
})

export const updateGadgetDashboardPanelResponse = (data) => ({
    type: DASHBOARD_PANEL_UPDATE_GADGET_RESPONSE,
    payload: data,
})

export const updateGadgetPositionDashboardPanel = (gadGets) => ({
    type: DASHBOARD_PANEL_UPDATE_POSITION_GADGET,
    payload: { gadGets },
})

export const updateGadgetPositionDashboardPanelResponse = (data) => ({
    type: DASHBOARD_PANEL_UPDATE_POSITION_GADGET_RESPONSE,
    payload: data,
})

export const searchDashboardUnits = () => ({
    type: DASHBOARD_PANEL_UNIT,
    payload: {},
})

export const searchDashboardUnitsResponse = (data) => ({
    type: DASHBOARD_PANEL_UNIT_RESPONSE,
    payload: data,
})

export const updateErrorUserGadgetResponse = (data) => ({
    type: DASHBOARD_PANEL_ERROR_USER_GADGET_RESPONSE,
    payload: data,
})
